export const removeKeys = <T>(keys: string[], obj: object): T =>
  Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key))) as T;
